import { RouteHttpVerb } from "../factory";
export const locationRestPluginGet = {
  path: "/plugin",
  method: RouteHttpVerb.GET
};